<template>
  <b-modal ref="modal" hide-footer centered title="Change column type" size="sm">
    <b-form @submit.prevent="save">
      <b-form-group label="Column type:">
        <b-form-select
          v-model="$v.newType.$model"
          :options="availableTypes"
          :class="{ 'is-invalid': $v.newType.$error }"
          :disabled="inProcess"
        />
        <b-form-invalid-feedback v-if="!$v.newType.required">Column type is required</b-form-invalid-feedback>
      </b-form-group>
      <b-button variant="success" type="submit" :disabled="inProcess">
        <b-spinner v-if="inProcess" small style="vertical-align: -2px;"></b-spinner>
        <span v-if="!inProcess">Change</span>
        <span v-else>Changing...</span>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import config from '@/config'
// services
import auth from '@/services/auth'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: ['gridId', 'options'],
  data() {
    return {
      cellKey: null,
      newType: null,
      inProcess: false,
    }
  },
  computed: {
    ...mapState(['currentDash']),
    availableTypes() {
      switch (this.currentType) {
        case 'string': return [
          { value: 'number', text: 'Number' },
          { value: 'date', text: 'Date' },
          { value: 'lookup', text: 'LookUp' },
          { value: 'multi_lookup', text: 'Multi LookUp' },
        ]
        case 'lookup': return [
          { value: 'multi_lookup', text: 'Multi LookUp' },
        ]
        default: return []
      }
    },
    currentType() {
      if (!this.cellKey) return null

      return this.options.meta[this.cellKey].type
    },
  },
  methods: {
    open(cellKey) {
      this.cellKey = cellKey

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      if (this.inProcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProcess = true

      if (this.currentType === this.newType) {
        this.close()
        return
      }

      const authToken = await auth.getIdToken()

      let payload = {
        authToken,
        gridId: this.gridId,
        dashId: this.currentDash,
        cellKey: this.cellKey,
        newType: this.newType,
        displayName: this.options.meta[this.cellKey].displayName,
      }

      const functionsUrl = config.midServer[process.env.APP_CONF.instance]

      this.$axios
        .get(`${functionsUrl}/dataGrid_changeColType`, {
          params: payload,
        })
        .then(res => {
          const { status } = res.data

          if (status === 'OK') {
            this.$popupRes({
              title: 'Success!',
              message: `Column type changed to "${this.newType}".`,
              variant: 'success',
            })

            this.cellKey = null
            this.newType = null
            this.inProcess = null

            this.close()

            setTimeout(() => {
              this.$v.$reset()
            })
          } else {
            this.inProcess = null

            this.$popupRes({
              title: 'Failed!',
              message: res.data.message,
              variant: 'danger',
            })
          }
        })
    },
  },
  created() {
    eventBus.$on(`showChangeColumnTypeModal`, this.open)
  },
  beforeDestroy() {
    eventBus.$off(`showChangeColumnTypeModal`, this.open)
  },
  validations: {
    newType: {
      required,
    },
  },
}
</script>
